export default {
    "enabled": true,
    "results_visibility_configuration_enabled": true
}